export enum Users {
  SUPPORT_ADMIN = "SupportAdmin",
  ADMIN = "Admin",
  WRITER = "Writer",
  READER = "Reader",
}
